import { makeStyles } from '@material-ui/core/styles';
import InfographicsImage from '../../../../assets/svg/infographicsMoreLikeThis.svg';
import InfographicsImageMobile from '../../../../assets/svg/infographicsMoreLikeThis_mobile.svg';
import { pxToRem } from '../../../../styles/themes/vad/constants';
const useStyles = makeStyles(theme => {
  const { left, right } = theme.mixins;
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      '&.withBg': {
        backgroundColor: ({ params }) =>
          (params && params.backgroundColor) || theme.palette.background.default,
        ...theme.shape.fullBleedingBox,
      },
      '& .infographicsbgImage-moreLikethis': {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        bottom: 0,
        ...right(0),
        ...left('auto'),
        height: '100%',
        width: '70%',
        transform: `scale(${theme.isDirectionRTL ? '-' : ''}1, 1)`,
        backgroundImage: `url(${InfographicsImage})`,
        [theme.breakpoints.down('md')]: {
          backgroundImage: `url(${InfographicsImageMobile})`,
          width: '67%',
        },
      },

      '& .Type3': {
        backgroundColor: 'transparent',
        marginBottom: 0,
        '& .slick-track': {
          [theme.breakpoints.down('lg')]: {
            paddingBottom: '83px',
          },
        },
        '& .slick-prev, & .slick-next': {
          top: '50%',
          transform: 'translateY(-50%)',
        },
        '& .slick-prev': {
          left: pxToRem(-20),
          right: 'auto',
        },
        '& .slick-next': {
          left: 'auto',
          right: pxToRem(-20),
        },
        '& .slick-prev > button, & .slick-next > button': {
          borderWidth: ({ params }) =>
            params && params.backgroundColor ? 0 : 1,
          backgroundColor: ({ params }) =>
            params && params.backgroundColor ? theme.mixins.White() : theme.mixins.White(0),
          '& svg': {
            color: ({ params }) =>
              params && params.backgroundColor ? theme.mixins.RussianViolet() : theme.mixins.Black(),
          },
          '&:hover': {
            backgroundColor: ({ params }) =>
              params && params.backgroundColor ? theme.mixins.RussianViolet() : theme.mixins.Black(300),
            '& svg': {
              color: ({ params }) =>
                params && params.backgroundColor ? theme.mixins.White() : theme.mixins.Black(),
            },
          },
        },
      },
      '& .main-heading': {
        color: ({ params }) => (params && params.textColor) || theme.palette.text.primary,
      },
    },
  }
});

export default useStyles;
